import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import EditarMateriasForm from './EditarMateriasForm';
import {
  fetchAllSubjectsBySemesters,
  saveSubjects,
  fetchEditSubjectsFormData,
} from '../../../../redux/actions/periodoActions';
import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../../../helpers/notification';
import { SidebarProps } from '../../../../shared/prop-types/ReducerProps';

class InscriptionContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      materiasModificadas: [],
      carrera: { value: 0, label: 'Todos' },
    };
  }

  componentDidMount() {
    this.fetchFormData();
    this.fetchSubjectList(0);
  }

  fetchFormData = () => {
    const { history, id: periodoId } = this.props;
    fetchEditSubjectsFormData(periodoId, {
      onSuccess: (formData) => {
        const { carreras } = formData;
        carreras.push({ value: 0, label: 'Todos' });
        this.setState({
          ...formData,
          carreras,
          loaded: true,
        });
      },
      onError: (error) => {
        if (error && error.status === 404) {
          createErrorMessage('El periodo no existe');
          history.push('/pages/periodo-subjects');
        } else {
          createErrorMessage('Error al intentar cargar los datos del periodo');
        }
      },
    });
  }

  fetchSubjectList = (carreraId) => {
    const { id: periodoId } = this.props;
    this.setState({ loaded: false });
    fetchAllSubjectsBySemesters({
      periodoId,
      carreraId,
      onSuccess: (subjects) => {
        this.setState({ subjects, loaded: true });
      },
      onError: () => {
        createErrorMessage('Error al intentar cargar las materias');
        this.setState({ loaded: false });
      },
    });
  }


  onMateriaPeriodoChanges = (id, evt) => {
    if (evt.target) {
      const { materiasModificadas } = this.state;
      const subject = materiasModificadas.find(i => i.materiaMallaId === id);
      if (!subject) {
        materiasModificadas.push({
          materiaMallaId: id,
          selected: evt.target.checked,
        });
        this.setState({ materiasModificadas });
      } else {
        subject.selected = evt.target.checked;
        this.setState({ materiasModificadas });
      }
    }
  }

  handleSubmit = () => {
    const { id: periodoId } = this.props;
    const { materiasModificadas } = this.state;
    const params = { materiasModificadas, periodoId: +periodoId };
    const { history } = this.props;
    saveSubjects(params,
      {
        onSuccess: () => {
          createSuccessMessage('Materias del periodo guardado exitosamente');
          history.push(`/pages/periodos/edit/${periodoId}`);
        },
        onError: (error) => {
          if (error.message) {
            createWarningMessage(error.message);
          } else {
            createErrorMessage('Ocurrió un error al intentar guardar las materias del periodo');
          }
        },
      });
  }

  onCarreraChanges = (carrera) => {
    this.setState({ carrera });
    this.fetchSubjectList(carrera.value);
  }

  handleOnBack = () => {
    const { history } = this.props;
    history.goBack();
  }

  render() {
    const { id, history } = this.props;
    const {
      periodo,
      loaded,
      subjects,
      carrera,
      carreras,
    } = this.state;


    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">
              Materias del periodo
            </h3>
            <h3 className="page-subhead subhead">
              {id ? 'Modifica ' : 'Ingresa '}
              la informaci&oacute;n de materias del periodo
            </h3>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {!(loaded && subjects && periodo)
              ? (<h3 className="page-subhead subhead">Cargando...</h3>)
              : (
                <EditarMateriasForm
                  {...periodo}
                  periodo={periodo}
                  carrera={carrera}
                  carreras={carreras}
                  onSubmit={this.handleSubmit}
                  onBack={this.handleOnBack}
                  initialValues={periodo}
                  history={history}
                  subjects={subjects}
                  onMateriaPeriodoChanges={this.onMateriaPeriodoChanges}
                  onCarreraChanges={this.onCarreraChanges}
                />
              )
            }
          </Col>
        </Row>
      </Container>
    );
  }
}

InscriptionContainer.propTypes = {
  id: PropTypes.string.isRequired,
  history: PropTypes.shape({}).isRequired,
  sidebar: SidebarProps.isRequired,
};

export default withRouter(connect(state => ({
  sidebar: state.sidebar,
}))(InscriptionContainer));
